import axios from 'axios';

const authEndpoint = 'https://accounts.spotify.com/authorize?';
const clientId = 'ea43895071664bbbad9b4e8273c44ebd';
const redirectUri = 'http://localhost:3000'
const scopes = ["user-read-currently-playing","user-library-read","playlist-read-private"];

export const loginEndPoint = `${authEndpoint}client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join("%20")}&response_type=token&show_dialog=true`;

const apiClient = axios.create({
    baseURL: 'https://api.spotify.com/v1'
});

export const setClientToken = (token) => {
    apiClient.interceptors.request.use(async function(config) {
        config.headers.Authorization ="Bearer " + token;
        return config;
    })
};

export default apiClient;